import React from "react";

const ICUPage = ({
  formData,
  handleChange,
  handleCheckboxChange,
  dtDisplay,
}) => {
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      // 이미 선택된 상태라면 해제
      handleChange({ target: { name, value: "" } });
    } else {
      // 다른 값이라면 선택
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러 (DateTime용)
  const handlePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 12) {
      // 자동 포맷팅 적용
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }
      if (numbers.length >= 8) {
        formattedValue =
          formattedValue.slice(0, 10) + " " + formattedValue.slice(10);
      }
      if (numbers.length >= 10) {
        formattedValue =
          formattedValue.slice(0, 13) + ":" + formattedValue.slice(13);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러 (Date 전용)
  const handleDatePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 8) {
      // YYYYMMDD 최대 8자리
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 날짜 자동 포맷팅 onChange 핸들러
  const handleDateChange = (e, fieldName) => {
    const input = e.target.value;

    // 백스페이스 처리
    if (input.length < (dtDisplay(formData[fieldName]) || "").length) {
      handleChange(e);
      return;
    }

    // 숫자만 추출
    const numbers = input.replace(/\D/g, "");

    if (numbers.length <= 8) {
      // YYYYMMDD 최대 8자리
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };
  return (
    <section className="vip-form-section">
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">Common</h3>

        {/* ICU 입실 경로 */}
        <div className="input-wrapper-1column">
          <label className="item_title_1col">
            ICU 입실 경로 (icu_adm_from)
          </label>
          <div className="input_1col">
            {["ER", "OR", "Ward", "High dependency unit", "Other hospital"].map(
              (opt) => (
                <label key={opt} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="icu_adm_from"
                    value={opt}
                    checked={formData.icu_adm_from === opt}
                    onClick={handleRadioClick}
                    onChange={() => {}} // 빈 함수로 React 경고 방지
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{opt}</div>
                </label>
              )
            )}
          </div>
        </div>

        {/* ICU 입실 일시 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 입실 일시 (icu_adm_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icu_adm_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.icu_adm_dt)}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length < (dtDisplay(formData.icu_adm_dt) || "").length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "icu_adm_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, "icu_adm_dt")}
              />
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* ICU 입실시 GCS 관련 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 입실시 GCS_E (icu_adm_gcs_e)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  { label: "2 : To pain", value: "2 : To pain" },
                  { label: "3 : To speech", value: "3 : To speech" },
                  { label: "4 : Spontaneously", value: "4 : Spontaneously" },
                  {
                    label: "Untestable (swollen)",
                    value: "0 : Untestable (swollen)",
                  },
                  {
                    label: "Untestable (other)",
                    value: "0 : Untestable (other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_adm_gcs_e"
                      value={option.value}
                      checked={formData.icu_adm_gcs_e === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICU 입실시 GCS_V (icu_adm_gcs_v)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Incomprehensible sound",
                    value: "2 : Incomprehensible sound",
                  },
                  {
                    label: "3 : Inappropriate words",
                    value: "3 : Inappropriate words",
                  },
                  { label: "4 : Confused", value: "4 : Confused" },
                  { label: "5 : Oriented", value: "5 : Oriented" },
                  {
                    label: "Untestable (tracheotomy/endotracheal tube)",
                    value: "0 : Untestable (tracheotomy/endotracheal tube)",
                  },
                  {
                    label: "Untestable (Other)",
                    value: "0 : Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_adm_gcs_v"
                      value={option.value}
                      checked={formData.icu_adm_gcs_v === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 입실시 GCS_M (icu_adm_gcs_m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Abnormal extension",
                    value: "2 : Abnormal extension",
                  },
                  {
                    label: "3 : Abnormal flexion",
                    value: "3 : Abnormal flexion",
                  },
                  {
                    label: "4 : Normal flexion/withdrawal",
                    value: "4 : Normal flexion/withdrawal",
                  },
                  {
                    label: "5 : Localizes to pain",
                    value: "5 : Localizes to pain",
                  },
                  {
                    label: "6 : Obeys commands",
                    value: "6 : Obeys commands",
                  },
                  {
                    label: "Untestable (Deep sedation/paralyzed)",
                    value: "0 : Untestable (Deep sedation/paralyzed)",
                  },
                  {
                    label: "Untestable (Other)",
                    value: "0 : Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_adm_gcs_m"
                      value={option.value}
                      checked={formData.icu_adm_gcs_m === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICU 입실시 GCS Total (icu_adm_gcs_total)
              <span className="tooltip-container">
                <span className="tooltip-icon">?</span>
                <span className="tooltip-text">
                  【GCS Total Score 자동계산 공식】
                  <br />
                  <br />
                  ★ 필수 입력 필드 (3개):
                  <br />
                  • icu_adm_gcs_e (Eye 반응)
                  <br />
                  • icu_adm_gcs_v (Verbal 반응)
                  <br />
                  • icu_adm_gcs_m (Motor 반응)
                  <br />
                  <br />
                  ★ 계산 로직:
                  <br />
                  1) E=0 또는 M=0인 경우
                  <br />
                  &nbsp;&nbsp;&nbsp;→ 총점 0점 (Untestable/Unknown)
                  <br />
                  <br />
                  2) V=0인 경우 (기관삽관 등):
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) ≤6: +1점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =7: +2점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) 8-9: +4점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =10: +5점
                  <br />
                  <br />
                  3) 그 외의 경우:
                  <br />
                  &nbsp;&nbsp;&nbsp;→ E + V + M 단순 합산
                  <br />
                  <br />★ 점수 범위: 0~15점
                </span>
              </span>
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icu_adm_gcs_total"
                value={formData.icu_adm_gcs_total || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Glasgow Coma Scale (GCS) - confounders type
              (icu_adm_gcs_confounder)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "No sedation or paralysis",
                    value: "No sedation or paralysis",
                  },
                  {
                    label: "Sedation",
                    value: "Sedation",
                  },
                  { label: "Paralysis", value: "Paralysis" },
                  {
                    label: "Temporary stop of sedation/paralysis",
                    value: "Temporary stop of sedation/paralysis",
                  },
                  {
                    label: "Reversal of sedation/paralysis",
                    value: "Reversal of sedation/paralysis",
                  },
                  {
                    label:
                      "Active reversal (pharmacologic) of sedation/paralysis",
                    value:
                      "Active reversal (pharmacologic) of sedation/paralysis",
                  },
                  { label: "Other", value: "Other" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_adm_gcs_confounder"
                      value={option.value}
                      checked={formData.icu_adm_gcs_confounder === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {option.value}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* ICP Monitor 관련 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitor 삽입 여부 (icp_monitor)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icp_monitor"
                      value={opt}
                      checked={formData.icp_monitor === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitor 종류 (icp_device)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "Ventricular",
                    value: "Ventricular",
                  },
                  {
                    label: "Parenchymal",
                    value: "Parenchymal",
                  },
                  {
                    label: "Epidural / Subdural",
                    value: "Epidural / Subdural",
                  },
                  {
                    label: "Other",
                    value: "Other",
                  },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icp_device"
                      value={option.value}
                      checked={formData.icp_device === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {option.value}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitor 삽입 일시 (icp_ins_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icp_ins_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.icp_ins_dt)}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length < (dtDisplay(formData.icp_ins_dt) || "").length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "icp_ins_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, "icp_ins_dt")}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitor 제거 일시 (icp_removal_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icp_removal_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.icp_removal_dt)}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length <
                    (dtDisplay(formData.icp_removal_dt) || "").length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "icp_removal_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, "icp_removal_dt")}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitor duration (icp_duration)
              <span className="tooltip-container">
                <span className="tooltip-icon">?</span>
                <span className="tooltip-text">
                  【ICP Monitor Duration 자동계산 공식】
                  <br />
                  <br />
                  ★ 필수 입력 필드 (2개):
                  <br />
                  • icp_ins_dt (ICP 모니터 삽입 일시)
                  <br />
                  • icp_removal_dt (ICP 모니터 제거 일시)
                  <br />
                  <br />
                  ★ 계산 공식:
                  <br />
                  Duration = 제거일시 - 삽입일시
                  <br />
                  <br />
                  ★ 단위: 분(minutes)
                  <br />
                  <br />
                  ★ 예시:
                  <br />
                  삽입: 2024-01-01 10:00
                  <br />
                  제거: 2024-01-03 14:30
                  <br />
                  → (2일 4시간 30분) = 3,270분
                  <br />
                  <br />★ 두 일시가 모두 입력되면 자동계산됩니다
                </span>
              </span>
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icp_duration"
                value={formData.icp_duration || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              />
              <span className="unit-text">분</span>
            </div>
          </div>

          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitoring 중단 이유 (icp_stop_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Clinically improved",
                  "ICP stable and < 20 mmHg",
                  "Monitor/catheter failure",
                  "Patient considered unsalvageable",
                  "Patient died",
                  "Other",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icp_stop_reason"
                      value={opt}
                      checked={formData.icp_stop_reason === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICP monitoring 중단 이유_기타 (icp_stop_reason_others)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icp_stop_reason_others"
                value={formData.icp_stop_reason_others || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* TTM 섹션 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">TTM 적용 여부 (ttm)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ttm"
                      value={opt}
                      checked={formData.ttm === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              TTM 시작 일시 (ttm_start_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="ttm_start_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.ttm_start_dt)}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length <
                    (dtDisplay(formData.ttm_start_dt) || "").length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "ttm_start_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, "ttm_start_dt")}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              TTM 종료 일시 (ttm_end_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="ttm_end_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.ttm_end_dt)}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length < (dtDisplay(formData.ttm_end_dt) || "").length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "ttm_end_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, "ttm_end_dt")}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              TTM 적용 기간 (ttm_duration)
              <span className="tooltip-container">
                <span className="tooltip-icon">?</span>
                <span className="tooltip-text">
                  【TTM Duration 자동계산 공식】
                  <br />
                  <br />
                  ★ 필수 입력 필드 (2개):
                  <br />
                  • ttm_start_dt (TTM 시작 일시)
                  <br />
                  • ttm_end_dt (TTM 종료 일시)
                  <br />
                  <br />
                  ★ 계산 공식:
                  <br />
                  Duration = 종료일시 - 시작일시
                  <br />
                  <br />
                  ★ 단위: 분(minutes)
                  <br />
                  <br />
                  ★ 예시:
                  <br />
                  시작: 2024-01-01 08:00
                  <br />
                  종료: 2024-01-02 20:00
                  <br />
                  → (1일 12시간) = 2,160분
                  <br />
                  <br />★ 두 일시가 모두 입력되면 자동계산됩니다
                </span>
              </span>
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="ttm_duration"
                value={formData.ttm_duration || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              />
              <span className="unit-text">분</span>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* DVT Prophylaxis 섹션 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Pharmacologic DVT prophylaxis 여부 (dvt_ppx_pharm)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="dvt_ppx_pharm"
                      value={opt}
                      checked={formData.dvt_ppx_pharm === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Type of pharmacologic prophylaxis (dvt_ppx_pharm_type)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Heparin", "Low molecular weight Heparin", "DOAC"].map(
                  (opt) => (
                    <label key={opt} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="dvt_ppx_pharm_type"
                        value={opt}
                        checked={formData.dvt_ppx_pharm_type === opt}
                        onClick={handleRadioClick}
                        onChange={() => {}} // 빈 함수로 React 경고 방지
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{opt}</div>
                    </label>
                  )
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Pharmacologic DVT prophylaxis 시작 일자 (dvt_ppx_pharm_start_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="dvt_ppx_pharm_start_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.dvt_ppx_pharm_start_d)}
                onChange={(e) => handleDateChange(e, "dvt_ppx_pharm_start_d")}
                onPaste={(e) => handleDatePaste(e, "dvt_ppx_pharm_start_d")}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Pharmacologic DVT prophylaxis 종료 일자 (dvt_ppx_pharm_stop_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="dvt_ppx_pharm_stop_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.dvt_ppx_pharm_stop_d)}
                onChange={handleChange}
                onPaste={(e) => handleDatePaste(e, "dvt_ppx_pharm_stop_d")}
              />
            </div>
          </div>
        </div>

        {/* Mechanical DVT ppx 섹션 */}

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Mechanical DVT prophylaxis 여부 (dvt_ppx_mech)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="dvt_ppx_mech"
                      value={opt}
                      checked={formData.dvt_ppx_mech === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Type of mechanical prophylaxis (dvt_ppx_mech_type)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Intermittent pneumatic compression",
                  "Anti-embolic stocking",
                  "Others",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="dvt_ppx_mech_type"
                      value={opt}
                      checked={formData.dvt_ppx_mech_type === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Mechanical DVT prophylaxis 시작 일자 (dvt_ppx_mech_start_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="dvt_ppx_mech_start_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.dvt_ppx_mech_start_d)}
                onChange={(e) => handleDateChange(e, "dvt_ppx_mech_start_d")}
                onPaste={(e) => handleDatePaste(e, "dvt_ppx_mech_start_d")}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Mechanical DVT prophylaxis 종료 일자 (dvt_ppx_mech_stop_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="dvt_ppx_mech_stop_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.dvt_ppx_mech_stop_d)}
                onChange={handleChange}
                onPaste={(e) => handleDatePaste(e, "dvt_ppx_mech_stop_d")}
              />
            </div>
          </div>
        </div>

        {/* Nutrition 섹션 */}
        {/* 정맥영양 여부, 정맥영양 시작 시간 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              정맥영양 여부 (nutri_parenteral)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="nutri_parenteral"
                      value={opt}
                      checked={formData.nutri_parenteral === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              첫 정맥영양 시작일 (nutri_parenteral_start_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="nutri_parenteral_start_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.nutri_parenteral_start_d)}
                onChange={(e) =>
                  handleDateChange(e, "nutri_parenteral_start_d")
                }
                onPaste={(e) => handleDatePaste(e, "nutri_parenteral_start_d")}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              장관영양 여부 (nutri_enteral)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="nutri_enteral"
                      value={opt}
                      checked={formData.nutri_enteral === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              첫 장관영양 시작일 (nutri_enteral_start_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="nutri_enteral_start_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.nutri_enteral_start_d)}
                onChange={(e) => handleDateChange(e, "nutri_enteral_start_d")}
                onPaste={(e) => handleDatePaste(e, "nutri_enteral_start_d")}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              장관영양 경로 (nutri_enteral_route)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  " Nasogastric tube",
                  "Transpyloric tube",
                  "Gastrostomy",
                  "Oral",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="nutri_enteral_route"
                      value={opt}
                      checked={formData.nutri_enteral_route === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* 기관삽관 여부*/}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">기관삽관 여부 (intu)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="intu"
                      value={opt}
                      checked={formData.intu === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column" />
        </div>

        {/* 기관삽관 시작 시각, 기관삽관 종료 시각*/}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              기관삽관 시작 시각 (intu_start_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="intu_start_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.intu_start_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.intu_start_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "intu_start_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              기관삽관 종료 시각 (intu_stop_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="intu_stop_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.intu_stop_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.intu_stop_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "intu_stop_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        {/* 기관삽관 종료 이유*/}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              기관삽관 종료 이유 (intu_stop_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Respiratory stable", "Accidental", "Withdrawal of care"].map(
                  (opt) => (
                    <label key={opt} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="intu_stop_reason"
                        value={opt}
                        checked={formData.intu_stop_reason === opt}
                        onClick={handleRadioClick}
                        onChange={() => {}} // 빈 함수로 React 경고 방지
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{opt}</div>
                    </label>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="block-2column" />
        </div>

        {/* 발관 후 재삽관 여부, 재삽관 시각 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              발관 후 재삽관 여부 (reintu)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="reintu"
                      value={opt}
                      checked={formData.reintu === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">재삽관 시각 (reintu_dt)</label>
            <div className="input_2col">
              <input
                type="text"
                name="reintu_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.reintu_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.reintu_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "reintu_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
        {/* 재삽관 이유 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              재삽관 이유 (reintu_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Neurological impairment",
                  "Respiratory failure",
                  "Airway failure",
                  "Cardiac failure",
                  "Surgery",
                  " Other",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="reintu_reason"
                      value={opt}
                      checked={formData.reintu_reason === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              재삽관 이유_기타 (reintu_reason_other)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="reintu_reason_other"
                value={formData.reintu_reason_other || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* Airway Management 섹션 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">인공호흡기 사용 여부 (mv)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="mv"
                      value={opt}
                      checked={formData.mv === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 인공호흡기 시작/종료 시각 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 시작 시각 (mv_start_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="mv_start_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.mv_start_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.mv_start_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "mv_start_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 종료 시각 (mv_stop_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="mv_stop_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.mv_stop_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.mv_stop_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "mv_stop_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        {/* 인공호흡기 이탈 후 재개 관련 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 이탈 후 재개 여부 (remv)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="remv"
                      value={opt}
                      checked={formData.remv === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 이탈 후 재개 시각 (remv_start_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="remv_start_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.remv_start_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.remv_start_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "remv_start_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 이탈 후 재개 이유 (remv_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Respiratory failure",
                  "Neurologic deterioration",
                  "Spontaneous hyperventilation",
                  "Sepsis",
                  "Other",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="remv_reason"
                      value={opt}
                      checked={formData.remv_reason === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              인공호흡기 이탈 후 재개 이유_기타 (remv_reason_other)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="remv_reason_other"
                value={formData.remv_reason_other || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* 기관절개 관련 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">기관절개 여부 (trach)</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["No", "Yes"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="trach"
                      value={opt}
                      checked={formData.trach === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              기관절개 이유 (trach_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label:
                      "Expected long duration of mechanical ventilation because of severe neurological damages",
                    value:
                      "Expected long duration of mechanical ventilation because of severe neurological damages",
                  },
                  { label: "Extubation failure", value: "Extubation failure" },
                  {
                    label: "Neurologic impairment",
                    value: "Neurologic impairment",
                  },
                  { label: "Airway failure", value: "Airway failure" },
                  {
                    label: "Severe face and/or neck trauma",
                    value: "Severe face and/or neck trauma",
                  },
                  {
                    label: "Chronic respiratory disease",
                    value: "Chronic respiratory disease",
                  },
                  { label: "Other", value: "Other" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="trach_reason"
                      value={option.value}
                      checked={formData.trach_reason === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              기관절개 이유_기타 (trach_reason_other)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="trach_reason_other"
                value={formData.trach_reason_other || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="block-2column" />
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              기관절개 일자 (trach_start_d)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="trach_start_d"
                placeholder="YYYY-MM-DD"
                value={dtDisplay(formData.trach_start_d)}
                onChange={(e) => handleDateChange(e, "trach_start_d")}
                onPaste={(e) => handleDatePaste(e, "trach_start_d")}
              />
            </div>
          </div>

          <div className="block-2column" />
        </div>

        {/* ICU Discharge 섹션 */}

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실 일시 (icu_dis_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icu_dis_dt"
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData.icu_dis_dt) || ""}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  const currentValue = dtDisplay(formData.icu_dis_dt) || "";
                  if (input.length < currentValue.length) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: "icu_dis_dt",
                        value: formattedValue,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실시 생존 여부 (icu_dis_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {["Alive", "Dead"].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_status"
                      value={opt}
                      checked={formData.icu_dis_status === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실 후 장소 (icu_dis_to)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "General ward",
                  "Other ICU",
                  "Other hospital (2차병원 이상)",
                  "Home",
                  "Nursing home (요양재활병원/요양원)",
                  "Step down/high care unit (SubICU)",
                  "Unknown",
                  "Other",
                ].map((opt) => (
                  <label key={opt} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_to"
                      value={opt}
                      checked={formData.icu_dis_to === opt}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{opt}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* ICU 퇴실시 GCS 관련 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실시 GCS_E (icu_dis_gcs_e)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  { label: "2 : To pain", value: "2 : To pain" },
                  { label: "3 : To speech", value: "3 : To speech" },
                  { label: "4 : Spontaneously", value: "4 : Spontaneously" },
                  {
                    label: "Untestable (swollen)",
                    value: "0 : Untestable (swollen)",
                  },
                  {
                    label: "Untestable (other)",
                    value: "0 : Untestable (other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_gcs_e"
                      value={option.value}
                      checked={formData.icu_dis_gcs_e === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실시 GCS_V (icu_dis_gcs_v)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Incomprehensible sound",
                    value: "2 : Incomprehensible sound",
                  },
                  {
                    label: "3 : Inappropriate words",
                    value: "3 : Inappropriate words",
                  },
                  { label: "4 : Confused", value: "4 : Confused" },
                  { label: "5 : Oriented", value: "5 : Oriented" },
                  {
                    label: "Untestable (tracheotomy/endotracheal tube)",
                    value: "0 : Untestable (tracheotomy/endotracheal tube)",
                  },
                  {
                    label: "Untestable (Other)",
                    value: "0 : Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_gcs_v"
                      value={option.value}
                      checked={formData.icu_dis_gcs_v === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실시 GCS_M (icu_dis_gcs_m)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "1 : None", value: "1 : None" },
                  {
                    label: "2 : Abnormal extension",
                    value: "2 : Abnormal extension",
                  },
                  {
                    label: "3 : Abnormal flexion",
                    value: "3 : Abnormal flexion",
                  },
                  {
                    label: "4 : Normal flexion/withdrawal",
                    value: "4 : Normal flexion/withdrawal",
                  },
                  {
                    label: "5 : Localizes to pain",
                    value: "5 : Localizes to pain",
                  },
                  {
                    label: "6 : Obeys commands",
                    value: "6 : Obeys commands",
                  },
                  {
                    label: "Untestable (Deep sedation/paralyzed)",
                    value: "0 : Untestable (Deep sedation/paralyzed)",
                  },
                  {
                    label: "Untestable (Other)",
                    value: "0 : Untestable (Other)",
                  },
                  { label: "Unknown", value: "0 : Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_gcs_m"
                      value={option.value}
                      checked={formData.icu_dis_gcs_m === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "13px" }}>
                      {option.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Glasgow Coma Scale (GCS) - confounders type
              (icu_dis_gcs_confounder)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  {
                    label: "No sedation or paralysis",
                    value: "No sedation or paralysis",
                  },
                  {
                    label: "Sedated",
                    value: "Sedated",
                  },
                  { label: "Paralyzed", value: "Paralyzed" },
                  {
                    label: "Temporary stop of sedation/paralysis",
                    value: "Temporary stop of sedation/paralysis",
                  },
                  {
                    label: "Reversal of sedation/paralysis",
                    value: "Reversal of sedation/paralysis",
                  },
                  {
                    label:
                      "Active reversal (pharmacologic) of sedation/paralysis",
                    value:
                      "Active reversal (pharmacologic) of sedation/paralysis",
                  },
                  { label: "Other", value: "Other" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_dis_gcs_confounder"
                      value={option.value}
                      checked={formData.icu_dis_gcs_confounder === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text" style={{ fontSize: "12px" }}>
                      {option.value}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ICU 퇴실 직전 GCS Total */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              ICU 퇴실 직전 GCS 합계 (icu_dis_gcs_total)
              <span className="tooltip-container">
                <span className="tooltip-icon">?</span>
                <span className="tooltip-text">
                  【GCS Total Score 자동계산 공식】
                  <br />
                  <br />
                  ★ 필수 입력 필드 (3개):
                  <br />
                  • icu_dis_gcs_e (Eye 반응)
                  <br />
                  • icu_dis_gcs_v (Verbal 반응)
                  <br />
                  • icu_dis_gcs_m (Motor 반응)
                  <br />
                  <br />
                  ★ 계산 로직:
                  <br />
                  1) E=0 또는 M=0인 경우
                  <br />
                  &nbsp;&nbsp;&nbsp;→ 총점 0점 (Untestable/Unknown)
                  <br />
                  <br />
                  2) V=0인 경우 (기관삽관 등):
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) ≤6: +1점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =7: +2점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) 8-9: +4점
                  <br />
                  &nbsp;&nbsp;&nbsp;→ (E+M) =10: +5점
                  <br />
                  <br />
                  3) 그 외의 경우:
                  <br />
                  &nbsp;&nbsp;&nbsp;→ E + V + M 단순 합산
                  <br />
                  <br />★ 점수 범위: 0~15점
                </span>
              </span>
            </label>
            <div className="input_2col">
              <input
                type="text"
                name="icu_dis_gcs_total"
                value={formData.icu_dis_gcs_total || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              />
            </div>
          </div>
          <div className="block-2column" />
        </div>

        {/* ICU Status */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Completion status_2</label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { v: "Not started", l: "Not started" },
                  { v: "In process", l: "In process" },
                  { v: "Complete", l: "Complete" },
                ].map(({ v, l }) => (
                  <label key={v} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="icu_status"
                      value={v}
                      checked={formData.icu_status === v}
                      onClick={handleRadioClick}
                      onChange={() => {}} // 빈 함수로 React 경고 방지
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{l}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column"> </div>
        </div>
      </div>
    </section>
  );
};

export default ICUPage;
